export function initMenu(container = document) {
  const menuItems = container.querySelectorAll('details.menu__item');
  // active : liens de navigation uniquement (<a href>), hors menus d'actions (data-menu-actions).
  // Un <button> d'action ne reçoit pas active et ne le retire pas à la navigation.
  const isNavLink = (el) => el.matches('a[href]') && !el.closest('[data-menu-actions]');
  const subLinks = [...container.querySelectorAll('.menu__sublink')].filter(isNavLink);
  const simpleLinks = [...container.querySelectorAll('.menu__link:not([aria-controls]):not(summary.menu__link)')].filter(isNavLink);

  // Gestion des tiroirs (summary)
  menuItems.forEach(item => {
    const summary = item.querySelector('summary.menu__link');
    if (!summary) return;

    summary.addEventListener('click', e => {
      e.preventDefault();

      // Ferme tous les autres tiroirs
      menuItems.forEach(otherItem => {
        if (otherItem !== item) otherItem.removeAttribute('open');
      });

      // Toggle le tiroir courant
      if (item.hasAttribute('open')) {
        item.removeAttribute('open');
      } else {
        item.setAttribute('open', '');
      }
    });
  });

  // Gestion des sous-liens
  subLinks.forEach(link => {
    link.addEventListener('click', () => {
      // Supprime active sur tous les subLinks et simpleLinks
      subLinks.forEach(l => l.classList.remove('active'));
      simpleLinks.forEach(l => l.classList.remove('active'));

      link.classList.add('active');

      const parentItem = link.closest('details.menu__item');
      if (parentItem) {
        parentItem.setAttribute('open', '');
        menuItems.forEach(otherItem => {
          if (otherItem !== parentItem) otherItem.removeAttribute('open');
        });
      }
    });
  });

  // Gestion des liens simples (sans sous-menu)
  simpleLinks.forEach(link => {
    link.addEventListener('click', () => {
      // Supprime active sur tous les subLinks et simpleLinks
      subLinks.forEach(l => l.classList.remove('active'));
      simpleLinks.forEach(l => l.classList.remove('active'));

      link.classList.add('active');

      // Ferme tous les tiroirs
      menuItems.forEach(item => item.removeAttribute('open'));
    });
  });

  // --- Gestion spécifique aux menus horizontaux ---
  // Sous-menus de premier niveau uniquement (ouvrir un sous-sous-menu ne doit pas fermer son parent)
  const horizontalMenus = Array.from(
    container.querySelectorAll('.menu--horizontal details.menu__item, .menu--horizontal details.menu__details')
  ).filter(d => !d.parentElement.closest('details'));

  // Fermer les autres sous-menus quand un nouveau s'ouvre
  horizontalMenus.forEach(details => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        horizontalMenus.forEach(other => {
          if (other !== details) other.removeAttribute('open');
        });
      }
    });
  });

  // Fermer le menu si on clique ailleurs sur la page
  // Échap referme le sous-menu horizontal ouvert et rend le focus à son déclencheur
  horizontalMenus.forEach(details => {
    details.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !details.open) return;
      e.stopPropagation();
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });

  document.addEventListener('click', (e) => {
    horizontalMenus.forEach(details => {
      if (!details.contains(e.target)) {
        details.removeAttribute('open');
      }
    });
  });
}